import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

export default class ProductDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div style={{ display: "flex" }}>
            {this.props.product
              ? languages.signupPage.editProduct
              : languages.signupPage.addProduct}
            <div style={{ flex: "1 1 10%" }} />
            {(this.props.tournament.lang || []).length > 1 && (
              <FormControl style={{ paddingRight: 9 }}>
                {/* <InputLabel htmlFor="reqOrOpt">
                  {languages.general.language}
                </InputLabel> */}
                <Select
                  value={this.props.lang || "0"}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "lang",
                    id: "lang",
                  }}
                  style={{ minWidth: 50 }}
                >
                  <MenuItem value={"0"}>
                    {(this.props.tournament.lang || [])[0].toUpperCase()}
                  </MenuItem>
                  {(this.props.tournament.lang || []).slice(1).map((lang) => {
                    return (
                      <MenuItem key={lang} value={lang}>
                        {lang.toUpperCase()}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
          </div>
        </DialogTitle>
        <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
          <DialogContentText />
          <TextField
            margin="dense"
            label={languages.signupPage.productName}
            value={this.props.name}
            name="name"
            onChange={
              this.props.lang !== "0"
                ? this.props.handleTrsNameChange
                : this.props.handleChange
            }
            type="text"
            fullWidth
          />
          <br />
          <br />
          <TextField
            fullWidth
            placeholder="0"
            name="price"
            value={this.props.price}
            label={languages.signupPage.pricePerProduct}
            onChange={this.props.handlePriceChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <br />
          <br />
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.props.alwaysAdd}
                  onChange={this.props.handleCheck}
                  name="alwaysAdd"
                  color="primary"
                />
              }
              label={languages.signupPage.alwaysAdd}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSubmit}
            disabled={this.props.submitDisabled}
            variant="contained"
            color="primary"
            type="submit"
          >
            {this.props.product
              ? languages.general.save
              : languages.general.add}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
